export const RESTAURANTS_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING";

export const RESTAURANT_OFFER_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/offers/restaurant?lat=22.73651&lng=75.889219&offset=0";

export const RESTAURANTS_IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"
// "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

// export const RESTAURANT_MENU_URL =
//   "https://corsanywhere.herokuapp.com/https://www.swiggy.com/dapi/menu/v4/full?lat=22.73651&lng=75.889219&menuId=";
export const RESTAURANT_MENU_URL =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=";

export const RESTAURANT_SUGGESTIONS_URL =
  "https://www.swiggy.com/dapi/restaurants/search/suggest?lat=22.73651&lng=75.889219&str=piz&trackingId=undefined";

export const RESTAURANTS_DATA_OBJ = {
  statusCode: 0,
  data: {
    cacheExpiryTime: 320,
    pages: 1,
    pageIndex: 0,
    scrubber: 0,
    filters: [
      {
        type: "FilterWidget",
        title: "Cuisines",
        key: "CUISINES",
        configType: "checkbox",
        visible: 1,
        options: [
          {
            option: "American",
            selected: 0,
            visible: 1,
          },
          {
            option: "Andhra",
            selected: 0,
            visible: 1,
          },
          {
            option: "Asian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bakery",
            selected: 0,
            visible: 1,
          },
          {
            option: "Barbecue",
            selected: 0,
            visible: 1,
          },
          {
            option: "Bengali",
            selected: 0,
            visible: 1,
          },
          {
            option: "Beverages",
            selected: 0,
            visible: 1,
          },
          {
            option: "Biryani",
            selected: 0,
            visible: 1,
          },
          {
            option: "Burgers",
            selected: 0,
            visible: 1,
          },
          {
            option: "Cafe",
            selected: 0,
            visible: 1,
          },
          {
            option: "Chaat",
            selected: 0,
            visible: 1,
          },
          {
            option: "Chinese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Combo",
            selected: 0,
            visible: 1,
          },
          {
            option: "Continental",
            selected: 0,
            visible: 1,
          },
          {
            option: "Desserts",
            selected: 0,
            visible: 1,
          },
          {
            option: "Fast Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Grill",
            selected: 0,
            visible: 1,
          },
          {
            option: "Gujarati",
            selected: 0,
            visible: 1,
          },
          {
            option: "Healthy Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Home Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Hyderabadi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Ice Cream",
            selected: 0,
            visible: 1,
          },
          {
            option: "Ice Cream Cakes",
            selected: 0,
            visible: 1,
          },
          {
            option: "Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Italian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Italian-American",
            selected: 0,
            visible: 1,
          },
          {
            option: "Jain",
            selected: 0,
            visible: 1,
          },
          {
            option: "Japanese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Juices",
            selected: 0,
            visible: 1,
          },
          {
            option: "Kebabs",
            selected: 0,
            visible: 1,
          },
          {
            option: "Kerala",
            selected: 0,
            visible: 1,
          },
          {
            option: "Keto",
            selected: 0,
            visible: 1,
          },
          {
            option: "Lebanese",
            selected: 0,
            visible: 1,
          },
          {
            option: "Lucknowi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Maharashtrian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mediterranean",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mexican",
            selected: 0,
            visible: 1,
          },
          {
            option: "Middle Eastern",
            selected: 0,
            visible: 1,
          },
          {
            option: "Mughlai",
            selected: 0,
            visible: 1,
          },
          {
            option: "Navratri Special",
            selected: 0,
            visible: 1,
          },
          {
            option: "Nepalese",
            selected: 0,
            visible: 1,
          },
          {
            option: "North Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Oriental",
            selected: 0,
            visible: 1,
          },
          {
            option: "Oriya",
            selected: 0,
            visible: 1,
          },
          {
            option: "Paan",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pan-Asian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pastas",
            selected: 0,
            visible: 1,
          },
          {
            option: "Persian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pizzas",
            selected: 0,
            visible: 1,
          },
          {
            option: "Punjabi",
            selected: 0,
            visible: 1,
          },
          {
            option: "Rajasthani",
            selected: 0,
            visible: 1,
          },
          {
            option: "Salads",
            selected: 0,
            visible: 1,
          },
          {
            option: "Seafood",
            selected: 0,
            visible: 1,
          },
          {
            option: "Snacks",
            selected: 0,
            visible: 1,
          },
          {
            option: "South Indian",
            selected: 0,
            visible: 1,
          },
          {
            option: "Street Food",
            selected: 0,
            visible: 1,
          },
          {
            option: "Sweets",
            selected: 0,
            visible: 1,
          },
          {
            option: "Tandoor",
            selected: 0,
            visible: 1,
          },
          {
            option: "Thai",
            selected: 0,
            visible: 1,
          },
          {
            option: "Thalis",
            selected: 0,
            visible: 1,
          },
          {
            option: "Waffle",
            selected: 0,
            visible: 1,
          },
        ],
        detail: "",
        heading: "Cuisines",
        applicable: 1,
        searchable: 1,
      },
      {
        type: "FilterWidget",
        title: "Show Restaurants With",
        key: "SHOW_RESTAURANTS_WITH",
        configType: "checkbox",
        visible: 1,
        options: [
          {
            option: "Offers",
            selected: 0,
            visible: 1,
          },
          {
            option: "Pure Veg",
            selected: 0,
            visible: 1,
          },
        ],
        detail: "",
        heading: "Offers & More",
        applicable: 1,
        searchable: 0,
      },
    ],
    sorts: [
      {
        type: "SortWidget",
        key: "RELEVANCE",
        title: "Relevance",
        selected: 1,
        visible: 1,
        defaultSelection: true,
      },
      {
        type: "SortWidget",
        key: "DELIVERY_TIME",
        title: "Delivery Time",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "RATING",
        title: "Rating",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "COST_FOR_TWO",
        title: "Cost: Low to High",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
      {
        type: "SortWidget",
        key: "COST_FOR_TWO_H2L",
        title: "Cost: High to Low",
        selected: 0,
        visible: 1,
        defaultSelection: false,
      },
    ],
    configs: {
      ribbons: {
        PREORDER: {
          type: "PREORDER",
          text: "Preorder",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 3,
        },
        EXCLUSIVE: {
          type: "EXCLUSIVE",
          text: "Exclusive",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 2,
        },
        NEW: {
          type: "NEW",
          text: "Newly Added",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 4,
        },
        REPEAT: {
          type: "REPEAT",
          text: "Repeat",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#D53D4C",
          bottomBackgroundColor: "#B02331",
          priority: 6,
        },
        CLOUD: {
          type: "CLOUD",
          text: "Daily Menus",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 5,
        },
        PREMIUM: {
          type: "PREMIUM",
          text: "Premium",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#8a584b",
          bottomBackgroundColor: "#583229",
          priority: 7,
        },
        PROMOTED: {
          type: "PROMOTED",
          text: "Promoted",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#3a3c41",
          bottomBackgroundColor: "#1e2023",
          priority: 1,
        },
      },
      croutons: {
        RAIN: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "${amount} extra levied on some restaurants",
        },
        RAIN_DEFAULT: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "Your orders may be delayed by 5-10 mins",
        },
        SERVICEABLE_WITH_BANNER_RAIN: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "rain_crouton_4x",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "Few restaurants unserviceable due to rains",
        },
        RAIN_LOW: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "Your orders may be delayed by 5-10 mins",
        },
        RAIN_HIGH: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "Bad Weather",
          message: "Your orders may be delayed by 5-10 mins",
        },
        SPECIAL: {
          type: "Crouton",
          bgColor: "#282C3F",
          icon: "surge_listing_piuzrv",
          textColor: "#ffffff",
          title: "High Demand",
          message: "Surge fee of Rs ${amount} may be applicable",
        },
      },
    },
    cards: [
      {
        cardType: "carousel",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "carousel",
          subtype: "topCarousel",
          data: {
            cards: [
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 378981,
                  creativeId: "rng/md/carousel/production/ef3i0k1ilhdsistcykog",
                  type: "restaurantCollectionV2",
                  link: "56407",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 304997,
                  creativeId: "rng/md/carousel/production/awurei8ypqkafoqay9ym",
                  type: "restaurantCollectionV2",
                  link: "47668",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181635,
                  creativeId: "rng/md/carousel/production/yparhmxrby5lv0ubsel4",
                  type: "restaurantCollectionV2",
                  link: "56413",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 607195,
                  creativeId: "rng/md/carousel/production/ifi2lbzxeu1hvsqrsip3",
                  type: "restaurantCollectionV2",
                  link: "56421",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  thirdPartyVendor: "",
                  thirdPartyAddress: false,
                },
              },
            ],
          },
        },
        parentWidget: false,
      },
      {
        cardType: "carousel",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "carousel",
          subtype: "openFilter",
          data: {
            cards: [
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181684,
                  creativeId: "bkhjfipzydkoqncrxpyi",
                  type: "restaurantCollectionV2",
                  link: "11718",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Offers Near You",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Offers Near You",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon: "eyperwsfhaoa5vktjtu4",
                  dwebOpenFilterDeselectIcon: "urw8usdf4mk9aywd59gq",
                },
              },
              {
                type: "carouselElement",
                subtype: "image",
                data: {
                  bannerId: 181680,
                  creativeId: "a3jqjjod5taken7dh1bs",
                  type: "restaurantCollectionV2",
                  link: "11721",
                  cityId: 0,
                  restaurantUuid: "",
                  restaurantParentId: "0",
                  title: "Veg Only",
                  subtitle: "0 OPTIONS",
                  restaurants: [],
                  totalCount: 0,
                  dwebOpenFilterTitle: "Vegetarian Options",
                  dwebOpenFilterBgColor: "#FF0000",
                  dwebOpenFilterSelectIcon: "qtjc8dzfexg72lug37a0",
                  dwebOpenFilterDeselectIcon: "bm8bziikwyvwqsml1clm",
                },
              },
            ],
          },
        },
        parentWidget: false,
      },
      {
        cardType: "seeAllRestaurants",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "seeAllRestaurants",
          data: {
            title: "SEE ALL",
            totalOpenRestaurants: 1161,
            cards: [
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "73831",
                  name: "Radhe Dhokla",
                  uuid: "aeabc7cb-61b3-4dd6-87a7-81f316267fdb",
                  city: "21",
                  area: "Nanpura",
                  totalRatingsString: "10000+ ratings",
                  cloudinaryImageId: "27947ad42435b18fc7d1f127e841748a",
                  cuisines: ["Chinese", "North Indian", "Biryani"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 22,
                  minDeliveryTime: 22,
                  maxDeliveryTime: 22,
                  slaString: "22 MINS",
                  lastMileTravel: 4.099999904632568,
                  slugs: {
                    restaurant: "radhe-dhokla-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Opposite Lalbhai Contractor Complex, Nr. Library Nanpura Main Road, Nanpura, Surat",
                  locality: "Navdi Bandar Road",
                  parentId: 4921,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "FLAT150 off",
                    shortDescriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹150 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "FLAT150 off | Use FLATDEAL",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 2400,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 2400,
                    message: "",
                    title: "Delivery Charge",
                    amount: "2400",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=6312863~p=22~eid=00000187-70ed-d82d-2abb-03870013164d",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "4 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "73831",
                    deliveryTime: 22,
                    minDeliveryTime: 22,
                    maxDeliveryTime: 22,
                    lastMileTravel: 4.099999904632568,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.4",
                  totalRatings: 10000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "514729",
                  name: "La Pino'z Pizza",
                  uuid: "84416cae-29af-4b85-ae8b-5c28358a65c6",
                  city: "21",
                  area: "Udhna Gam",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "i0wdxy1pfb7zhyuivtow",
                  cuisines: ["Pizzas", "Beverages", "Pastas"],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 19,
                  minDeliveryTime: 19,
                  maxDeliveryTime: 19,
                  slaString: "19 MINS",
                  lastMileTravel: 1.600000023841858,
                  slugs: {
                    restaurant: "la-pino’z-pizza-udhna-udhna",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "276/277/2 PLOT NO-52, BUILDING-A, SHOP NO-G-14 & G-16, GR FLOOR, SHASHWAT RESIDENCY, UDHNA, Surat City,394210",
                  locality: "Shanti Nagar",
                  parentId: 4961,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹249",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.6 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "514729",
                    deliveryTime: 19,
                    minDeliveryTime: 19,
                    maxDeliveryTime: 19,
                    lastMileTravel: 1.600000023841858,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.9",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "79331",
                  name: "Sarvottam Restaurant",
                  uuid: "0f2cb211-4d07-48ad-a7f0-82b405c84cb5",
                  city: "21",
                  area: "Udhna Gam",
                  totalRatingsString: "10000+ ratings",
                  cloudinaryImageId: "z4ldhn9m17fpxjksbcn1",
                  cuisines: [
                    "Chinese",
                    "North Indian",
                    "Ice Cream",
                    "Pizzas",
                    "Biryani",
                  ],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 16,
                  minDeliveryTime: 16,
                  maxDeliveryTime: 16,
                  slaString: "16 MINS",
                  lastMileTravel: 1.2000000476837158,
                  slugs: {
                    restaurant: "sarvottam-restaurant-varachha-varachha",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Shop No.1-16, First floor, Tulsi plaza complex, Udhna main Road, surat",
                  locality: "Chandanvan Society",
                  parentId: 178558,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.2 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "79331",
                    deliveryTime: 16,
                    minDeliveryTime: 16,
                    maxDeliveryTime: 16,
                    lastMileTravel: 1.2000000476837158,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.1",
                  totalRatings: 10000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "205488",
                  name: "Jay Jalaram Thali",
                  uuid: "14465b18-6e2c-42bf-b3ad-8a800d20da26",
                  city: "21",
                  area: "Gopipura",
                  totalRatingsString: "10000+ ratings",
                  cloudinaryImageId: "kih2hszmym1ygw2bokrl",
                  cuisines: ["North Indian", "Biryani", "Punjabi", "Chinese"],
                  tags: [],
                  costForTwo: 13000,
                  costForTwoString: "₹130 FOR TWO",
                  deliveryTime: 24,
                  minDeliveryTime: 24,
                  maxDeliveryTime: 24,
                  slaString: "24 MINS",
                  lastMileTravel: 3.700000047683716,
                  slugs: {
                    restaurant: "jay-jalaram-thali-varachha-varachha",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "1/3277, Behind Venus Chambers, Near Jain Bhojanshala, Kaji Maidan, Gopipura, Surat 395001",
                  locality: "Kaji Maidan",
                  parentId: 110113,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "3.7 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "205488",
                    deliveryTime: 24,
                    minDeliveryTime: 24,
                    maxDeliveryTime: 24,
                    lastMileTravel: 3.700000047683716,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.6",
                  totalRatings: 10000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "408520",
                  name: "Bhandari Vishwas Tiffin Corner",
                  uuid: "4c18c9bd-f602-4de8-8afc-f3c47256958e",
                  city: "21",
                  area: "Udhna Gam",
                  totalRatingsString: "100+ ratings",
                  cloudinaryImageId: "u3xxri5oxhznm8hceuxp",
                  cuisines: ["Thalis", "North Indian"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 18,
                  minDeliveryTime: 18,
                  maxDeliveryTime: 18,
                  slaString: "18 MINS",
                  lastMileTravel: 1.100000023841858,
                  slugs: {
                    restaurant: "bhandari-vishwas-tiffin-corner-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Plot no C 72, shiv krupa society amba nagar UM road behind unique hospital, Inderpura surat (395002)",
                  locality: "Shiv Krupa Society",
                  parentId: 242051,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.1 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "408520",
                    deliveryTime: 18,
                    minDeliveryTime: 18,
                    maxDeliveryTime: 18,
                    lastMileTravel: 1.100000023841858,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.9",
                  totalRatings: 100,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "100721",
                  name: "McDonald's",
                  uuid: "64cad596-c1f0-4dd9-80e7-aee762237a74",
                  city: "21",
                  area: "Rustampura",
                  totalRatingsString: "5000+ ratings",
                  cloudinaryImageId: "7bb739d7f6ae8b4ce8ed590765dffd2f",
                  cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
                  tags: [],
                  costForTwo: 40000,
                  costForTwoString: "₹400 FOR TWO",
                  deliveryTime: 23,
                  minDeliveryTime: 23,
                  maxDeliveryTime: 23,
                  slaString: "23 MINS",
                  lastMileTravel: 2.4000000953674316,
                  slugs: {
                    restaurant: "mcdonalds-reliance-mall-varachha",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Hardcastle Restaurants Pvt Ltd,McDonalds Family Restaurants, RSM 09, RSM 24-26, Reliance Mega Mall, Udhana Darwaja, Opp. Passport Office, Ring Road, Surat - 394210, Gujarat.",
                  locality: "Reliance Mall",
                  parentId: 630,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "2.4 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "100721",
                    deliveryTime: 23,
                    minDeliveryTime: 23,
                    maxDeliveryTime: 23,
                    lastMileTravel: 2.4000000953674316,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.3",
                  totalRatings: 5000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "79442",
                  name: "Asal Amdavadi Tava Fry",
                  uuid: "5026bcfa-12f7-401b-946b-37c5b1bc7271",
                  city: "21",
                  area: "Rander",
                  totalRatingsString: "10000+ ratings",
                  cloudinaryImageId: "00a1cedc70a9722c5f1832966a6e7b88",
                  cuisines: ["North Indian", "Biryani"],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 25,
                  minDeliveryTime: 25,
                  maxDeliveryTime: 25,
                  slaString: "25 MINS",
                  lastMileTravel: 7.5,
                  slugs: {
                    restaurant: "asal-amdavadi-tava-fry-adajan-adajan",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "9/70, PLOT NO. A/2, B & B/A/1, BORWADA, VACHALO MOHALLO, RANDER, SURAT",
                  locality: "Borwada",
                  parentId: 36677,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 4200,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 4200,
                    message: "",
                    title: "Delivery Charge",
                    amount: "4200",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=6312900~p=10~eid=00000187-70ed-d82d-2abb-038300130a28",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "7.5 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "79442",
                    deliveryTime: 25,
                    minDeliveryTime: 25,
                    maxDeliveryTime: 25,
                    lastMileTravel: 7.5,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "3.8",
                  totalRatings: 10000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "352546",
                  name: "Center Point -Gandhi Smruti",
                  uuid: "40e80a9b-83de-4ce0-9aeb-1d2a591a263a",
                  city: "21",
                  area: "Nanpura",
                  totalRatingsString: "10000+ ratings",
                  cloudinaryImageId: "eha3nb1wqvs0p00kdeaw",
                  cuisines: ["Chinese", "Burgers", "Pizzas"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 20,
                  minDeliveryTime: 20,
                  maxDeliveryTime: 20,
                  slaString: "20 MINS",
                  lastMileTravel: 3,
                  slugs: {
                    restaurant: "center-point-fast-food-athwa-athwa-2",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "S-49, KANAKNIDHI COMPLEX, OPP.GANDHI SMRUTI BHAVAN, TIMALIYAWAD, NANPURA, SURAT, Nanpura H.O, Surat Municipal Corporation, Surat Municipal Corporation, Gujarat",
                  locality: "Timaliyawad",
                  parentId: 56320,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "3 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "352546",
                    deliveryTime: 20,
                    minDeliveryTime: 20,
                    maxDeliveryTime: 20,
                    lastMileTravel: 3,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.0",
                  totalRatings: 10000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "612570",
                  name: "Satkar Restaurant",
                  uuid: "ac899f69-c26a-4ef7-82ca-c71cd686467b",
                  city: "21",
                  area: "Udhana",
                  totalRatingsString: "Too Few Ratings",
                  cloudinaryImageId: "tvexgisocwix7erzwvgz",
                  cuisines: ["North Indian", "Chinese"],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 21,
                  minDeliveryTime: 21,
                  maxDeliveryTime: 21,
                  slaString: "21 MINS",
                  lastMileTravel: 0.6000000238418579,
                  slugs: {
                    restaurant: "satkat-restaurent-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "27/A, TP-1, FP-122, SHOP NO-325, 1ST FLOOR,  UDHNA STATION SHOPPING SHOP HOLDERS  CO OP SOC. LTD., NR. CITY CENTER, BAMROLI  ROAD, UDHNA,, Surat Municipal Corporation,  Gujarat-394210",
                  locality: "Bamroli Road",
                  parentId: 21553,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "0.6 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "612570",
                    deliveryTime: 21,
                    minDeliveryTime: 21,
                    maxDeliveryTime: 21,
                    lastMileTravel: 0.6000000238418579,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "--",
                  totalRatings: 0,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "70056",
                  name: "Mahesh Pav Bhaji",
                  uuid: "ddff1260-76e5-4f99-92c3-242cd2d44f92",
                  city: "21",
                  area: "Athwa",
                  totalRatingsString: "5000+ ratings",
                  cloudinaryImageId: "f015ac61594dc1b4107f9b8735a8d2e7",
                  cuisines: ["Chinese", "South Indian"],
                  tags: [],
                  costForTwo: 30000,
                  costForTwoString: "₹300 FOR TWO",
                  deliveryTime: 21,
                  minDeliveryTime: 21,
                  maxDeliveryTime: 21,
                  slaString: "21 MINS",
                  lastMileTravel: 4.099999904632568,
                  slugs: {
                    restaurant: "mahesh-pav-bhaji-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "SMC Picnic Stall, Chowpati, Athwa Lines, Surat, Gujarat 395007",
                  locality: "Chowpati",
                  parentId: 6553,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 2400,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 2400,
                    message: "",
                    title: "Delivery Charge",
                    amount: "2400",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=6313302~p=13~eid=00000187-70ed-d82d-2abb-038400130d29",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "4 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "70056",
                    deliveryTime: 21,
                    minDeliveryTime: 21,
                    maxDeliveryTime: 21,
                    lastMileTravel: 4.099999904632568,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.1",
                  totalRatings: 5000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "93694",
                  name: "New Janta Dairy",
                  uuid: "4646d5ab-5240-4794-9f7a-b525726f10da",
                  city: "21",
                  area: "Althan Bhatar",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "mstdherryaqj9wj4qkyo",
                  cuisines: ["Desserts"],
                  tags: [],
                  costForTwo: 20000,
                  costForTwoString: "₹200 FOR TWO",
                  deliveryTime: 17,
                  minDeliveryTime: 17,
                  maxDeliveryTime: 17,
                  slaString: "17 MINS",
                  lastMileTravel: 0.6000000238418579,
                  slugs: {
                    restaurant: "new-janta-dairy-piplod-piplod",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "shop no 224, 1st floor, near manher dying udhna magdalla road, bhatiya complex surat",
                  locality: "Sosyo Circle",
                  parentId: 8623,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "Closes soon",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "0.6 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "93694",
                    deliveryTime: 17,
                    minDeliveryTime: 17,
                    maxDeliveryTime: 17,
                    lastMileTravel: 0.6000000238418579,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "4.2",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "680389",
                  name: "FruitLo Jenckee Fun Food",
                  uuid: "20844045-c601-4490-a133-9ab7fe8889ec",
                  city: "21",
                  area: "Athwa",
                  totalRatingsString: "Too Few Ratings",
                  cloudinaryImageId: "4e8dbe8688f92096b61b57e9c7936b4c",
                  cuisines: ["Healthy Food"],
                  tags: [],
                  costForTwo: 15000,
                  costForTwoString: "₹150 FOR TWO",
                  deliveryTime: 22,
                  minDeliveryTime: 22,
                  maxDeliveryTime: 22,
                  slaString: "22 MINS",
                  lastMileTravel: 0.5,
                  slugs: {
                    restaurant: "fruitlo-jenckee-fun-food-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "PLOT NO 14/A, SHREE RANCHHODNAGAR INDUSTRIAL ESTATE UDHNA MAGDALLA ROAD UDHNA 395007",
                  locality: "Shree Ranchhodnagar",
                  parentId: 406504,
                  unserviceable: false,
                  veg: false,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "0.5 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "680389",
                    deliveryTime: 22,
                    minDeliveryTime: 22,
                    maxDeliveryTime: 22,
                    lastMileTravel: 0.5,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "--",
                  totalRatings: 0,
                  new: true,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "65430",
                  name: "Urban Punjab",
                  uuid: "e88d0839-1b40-4cce-807a-9714072e2a5d",
                  city: "21",
                  area: "Adajan Gam",
                  totalRatingsString: "5000+ ratings",
                  cloudinaryImageId: "fuog43zissspekqlbhtt",
                  cuisines: [
                    "Punjabi",
                    "Indian",
                    "North Indian",
                    "Thalis",
                    "Biryani",
                    "Tandoor",
                    "Chinese",
                    "Pizzas",
                    "Pastas",
                  ],
                  tags: [],
                  costForTwo: 25000,
                  costForTwoString: "₹250 FOR TWO",
                  deliveryTime: 25,
                  minDeliveryTime: 25,
                  maxDeliveryTime: 25,
                  slaString: "25 MINS",
                  lastMileTravel: 5.800000190734863,
                  slugs: {
                    restaurant: "urban-punjab-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "86, Ground Floor, Shreeji Arcade, Anand Mahal Road, Adajan, Adajan Gam, Surat",
                  locality: "Anand Mahal Road",
                  parentId: 5265,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "Flat ₹125 off",
                    shortDescriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "₹125 OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "Flat ₹125 off on orders above ₹199 | Use code MATCHDEAL125",
                        discountType: "Flat",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  ribbon: [
                    {
                      type: "PROMOTED",
                    },
                  ],
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 2900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 2900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "2900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID:
                    "cid=6312928~p=16~eid=00000187-70ed-d82d-2abb-038500131072",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "5.8 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "65430",
                    deliveryTime: 25,
                    minDeliveryTime: 25,
                    maxDeliveryTime: 25,
                    lastMileTravel: 5.800000190734863,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: true,
                  avgRating: "4.0",
                  totalRatings: 5000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "221197",
                  name: "Nv Fastfood",
                  uuid: "41074d8e-bdae-49d2-9fc5-f31055313a0a",
                  city: "21",
                  area: "Udhna Gam",
                  totalRatingsString: "1000+ ratings",
                  cloudinaryImageId: "yu78pjchxpwfmotzuw8u",
                  cuisines: ["Chinese"],
                  tags: [],
                  costForTwo: 15000,
                  costForTwoString: "₹150 FOR TWO",
                  deliveryTime: 19,
                  minDeliveryTime: 19,
                  maxDeliveryTime: 19,
                  slaString: "19 MINS",
                  lastMileTravel: 1.5,
                  slugs: {
                    restaurant: "nv-fastfood-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Shop G-2, Saswat Residency, Santi Nagar, Udhna, Surat",
                  locality: "Santi Nagar",
                  parentId: 150693,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "40% off",
                    shortDescriptionList: [
                      {
                        meta: "40% off | Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "40% off up to ₹80 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "40% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "40% off up to ₹80 | Use code TRYNEW",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.5 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "221197",
                    deliveryTime: 19,
                    minDeliveryTime: 19,
                    maxDeliveryTime: 19,
                    lastMileTravel: 1.5,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "3.9",
                  totalRatings: 1000,
                  new: false,
                },
                subtype: "basic",
              },
              {
                type: "restaurant",
                data: {
                  type: "F",
                  id: "447173",
                  name: "Shree Radhey Fastfood",
                  uuid: "ee912ed3-69df-4d5b-b723-f57a8721df81",
                  city: "21",
                  area: "Sagrampura",
                  totalRatingsString: "Too Few Ratings",
                  cloudinaryImageId: "m0ouvp5eh7gskj2xkhp9",
                  cuisines: ["Chinese", "Combo", "Snacks"],
                  tags: [],
                  costForTwo: 10000,
                  costForTwoString: "₹100 FOR TWO",
                  deliveryTime: 24,
                  minDeliveryTime: 24,
                  maxDeliveryTime: 24,
                  slaString: "24 MINS",
                  lastMileTravel: 1.100000023841858,
                  slugs: {
                    restaurant: "shree-radhey-fastfood-athwa-athwa",
                    city: "surat",
                  },
                  cityState: "21",
                  address:
                    "Navrang Ind soc, UM Rd, behind Sarvodaya petrol pump, Near Sosyo Circle, Udhna, Surat, Gujarat 395017, India",
                  locality: "Sosyo Circle",
                  parentId: 269159,
                  unserviceable: false,
                  veg: true,
                  select: false,
                  favorite: false,
                  tradeCampaignHeaders: [],
                  aggregatedDiscountInfo: {
                    header: "60% off",
                    shortDescriptionList: [
                      {
                        meta: "60% off | Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  aggregatedDiscountInfoV2: {
                    header: "60% OFF",
                    shortDescriptionList: [
                      {
                        meta: "Use WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    descriptionList: [
                      {
                        meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                      },
                    ],
                    subHeader: "",
                    headerType: 0,
                    superFreedel: "",
                  },
                  chain: [],
                  feeDetails: {
                    fees: [
                      {
                        name: "distance",
                        fee: 1900,
                        message: "",
                      },
                      {
                        name: "time",
                        fee: 0,
                        message: "",
                      },
                      {
                        name: "special",
                        fee: 0,
                        message: "",
                      },
                    ],
                    totalFees: 1900,
                    message: "",
                    title: "Delivery Charge",
                    amount: "1900",
                    icon: "",
                  },
                  availability: {
                    opened: true,
                    nextOpenMessage: "",
                    nextCloseMessage: "",
                  },
                  longDistanceEnabled: 0,
                  rainMode: "NONE",
                  thirdPartyAddress: false,
                  thirdPartyVendor: "",
                  adTrackingID: "",
                  badges: {
                    imageBased: [],
                    textBased: [],
                    textExtendedBadges: [],
                  },
                  lastMileTravelString: "1.1 kms",
                  hasSurge: false,
                  sla: {
                    restaurantId: "447173",
                    deliveryTime: 24,
                    minDeliveryTime: 24,
                    maxDeliveryTime: 24,
                    lastMileTravel: 1.100000023841858,
                    lastMileDistance: 0,
                    serviceability: "SERVICEABLE",
                    rainMode: "NONE",
                    longDistance: "NOT_LONG_DISTANCE",
                    preferentialService: false,
                    iconType: "EMPTY",
                  },
                  promoted: false,
                  avgRating: "--",
                  totalRatings: 0,
                  new: false,
                },
                subtype: "basic",
              },
            ],
            totalRestaurants: 1161,
          },
          subtype: "personalized",
        },
        parentWidget: false,
      },
    ],
    nextPageFetch: 0,
  },
  tid: "5d29f1ba-57e3-40af-9ea6-755f41a0fcea",
  sid: "6fw1a926-75d3-4ea9-8467-0ddc925abeda",
  deviceId: "ac04c0a7-9f93-eaec-ee26-b3479eb0e625",
  csrfToken: "4JUfpO4cEmyu-OMYbAiJMF7KxJIUp23QlFOhBE_4",
};

export const RESTAURANTS_OFFER_OBJ = {
  statusCode: 0,
  data: {
    cacheExpiryTime: 320,
    pages: 82,
    pageIndex: 0,
    scrubber: 0,
    configs: {
      ribbons: {
        PREORDER: {
          type: "PREORDER",
          text: "Preorder",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 3,
        },
        EXCLUSIVE: {
          type: "EXCLUSIVE",
          text: "Exclusive",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 2,
        },
        NEW: {
          type: "NEW",
          text: "Newly Added",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#d53d4c",
          bottomBackgroundColor: "#af2330",
          priority: 4,
        },
        REPEAT: {
          type: "REPEAT",
          text: "Repeat",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#D53D4C",
          bottomBackgroundColor: "#B02331",
          priority: 6,
        },
        CLOUD: {
          type: "CLOUD",
          text: "Daily Menus",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#fa4a5b",
          bottomBackgroundColor: "#d12a3b",
          priority: 5,
        },
        PREMIUM: {
          type: "PREMIUM",
          text: "Premium",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#8a584b",
          bottomBackgroundColor: "#583229",
          priority: 7,
        },
        PROMOTED: {
          type: "PROMOTED",
          text: "Promoted",
          textColor: "#ffffff",
          imageId: "sfefefefeegeg",
          topBackgroundColor: "#3a3c41",
          bottomBackgroundColor: "#1e2023",
          priority: 1,
        },
      },
    },
    totalSize: 1229,
    currentOffset: 0,
    cards: [
      {
        cardType: "messageCard",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "messageCard",
          data: {
            message: "All Offers (1228)",
          },
          subtype: "info",
          sticky: 1,
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "64532",
            name: "Sagar Gaire",
            uuid: "649f3a5c-ec4b-400d-8486-f8141e33e6bc",
            city: "18",
            area: "New Palasia",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "irki7zudjxrbbmtcvpgy",
            cuisines: ["Punjabi", "Chinese", "Italian", "Thalis"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 22,
            minDeliveryTime: 22,
            maxDeliveryTime: 22,
            slaString: "22 MINS",
            lastMileTravel: 1.899999976158142,
            slugs: {
              restaurant: "sagar-gaire-new-palasia-new-palasia",
              city: "indore",
            },
            cityState: "18",
            address:
              "Shop No.1, NM Tower, Chappan Dukan, Opposite Nafees Bakery, New Palasia, Indore",
            locality: "Chappan Dukan",
            parentId: 7049,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "FLAT125 off",
              shortDescriptionList: [
                {
                  meta: "FLAT125 off | Use FLATDEAL",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "FLAT125 off | Use FLATDEAL",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "₹125 OFF",
              shortDescriptionList: [
                {
                  meta: "Use FLATDEAL",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "FLAT125 off | Use FLATDEAL",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            ribbon: [
              {
                type: "PROMOTED",
              },
            ],
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
              "cid=6464035~p=1~eid=00000187-70ef-5d98-2ad3-45d500600115",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.8 kms",
            hasSurge: false,
            sla: {
              restaurantId: "64532",
              deliveryTime: 22,
              minDeliveryTime: 22,
              maxDeliveryTime: 22,
              lastMileTravel: 1.899999976158142,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.0",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "72574",
            name: "99 Rotiwala-L.I.G",
            uuid: "aa8e5401-43d0-4c97-9b04-59caa45e556c",
            city: "18",
            area: "Bhamori",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "qawk8v7texq2hijbfczh",
            cuisines: ["North Indian", "South Indian", "Punjabi", "Chinese"],
            tags: [],
            costForTwo: 15000,
            costForTwoString: "₹150 FOR TWO",
            deliveryTime: 21,
            minDeliveryTime: 21,
            maxDeliveryTime: 21,
            slaString: "21 MINS",
            lastMileTravel: 1.2000000476837158,
            slugs: {
              restaurant: "99-rotiwala-old-palasia-old-palasia",
              city: "indore",
            },
            cityState: "18",
            address:
              "161 A , Adarsh Mechenic Nagar, Bhamori, MR 9, opposite sai sampada building.",
            locality: "Adarsh Mechenic Nagar",
            parentId: 24437,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "15% off",
              shortDescriptionList: [
                {
                  meta: "15% off | Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "15% off up to ₹45 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "15% OFF",
              shortDescriptionList: [
                {
                  meta: "Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "15% off up to ₹45 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.2 kms",
            hasSurge: false,
            sla: {
              restaurantId: "72574",
              deliveryTime: 21,
              minDeliveryTime: 21,
              maxDeliveryTime: 21,
              lastMileTravel: 1.2000000476837158,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.8",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "199663",
            name: "Apna Sweets",
            uuid: "82580bcc-5bd9-4fd3-a257-0bb1339426fd",
            city: "18",
            area: "Sapna Sangeeta",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "lxu9imcxhokzm2ff4vxt",
            cuisines: [
              "North Indian",
              "Sweets",
              "Beverages",
              "Street Food",
              "South Indian",
              "Fast Food",
              "Chinese",
              "Desserts",
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 32,
            minDeliveryTime: 32,
            maxDeliveryTime: 32,
            slaString: "32 MINS",
            lastMileTravel: 5,
            slugs: {
              restaurant: "apna-sweets-bhawar-kuan-bhawar-kuan",
              city: "indore",
            },
            cityState: "18",
            address: "Opposite INOX, Sapna Sangeeta,Indore, Madhya Pradesh",
            locality: "Bhawar Kuan",
            parentId: 8960,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "Flat ₹125 off",
              shortDescriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "₹125 OFF",
              shortDescriptionList: [
                {
                  meta: "Use MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            ribbon: [
              {
                type: "PROMOTED",
              },
            ],
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 3900,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 3900,
              message: "",
              title: "Delivery Charge",
              amount: "3900",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
              "cid=6463644~p=4~eid=00000187-70ef-5d98-2ad3-45d60060042f",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "5 kms",
            hasSurge: false,
            sla: {
              restaurantId: "199663",
              deliveryTime: 32,
              minDeliveryTime: 32,
              maxDeliveryTime: 32,
              lastMileTravel: 5,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.1",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "402511",
            name: "Pandit Food Service",
            uuid: "b7b7c06c-3efa-49d8-a78b-95e3e45577d3",
            city: "18",
            area: "Vijay Nagar",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "wvhjhoennezzrro41ua3",
            cuisines: [
              "North Indian",
              "Indian",
              "Thalis",
              "Chinese",
              "Tandoor",
              "Desserts",
            ],
            tags: [],
            costForTwo: 15000,
            costForTwoString: "₹150 FOR TWO",
            deliveryTime: 30,
            minDeliveryTime: 30,
            maxDeliveryTime: 30,
            slaString: "30 MINS",
            lastMileTravel: 2.5,
            slugs: {
              restaurant: "pandit-food-service-vijay-nagar-vijay-nagar",
              city: "indore",
            },
            cityState: "18",
            address:
              "SHOP NO L G 28 MANGAL CITY MALL VIJAY NAGAR INDORE, Indore, Indore, Indore, Madhya Pradesh - 452010",
            locality: "Mangal City Mall",
            parentId: 252323,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "Flat ₹125 off",
              shortDescriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "₹125 OFF",
              shortDescriptionList: [
                {
                  meta: "Use MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "2.5 kms",
            hasSurge: false,
            sla: {
              restaurantId: "402511",
              deliveryTime: 30,
              minDeliveryTime: 30,
              maxDeliveryTime: 30,
              lastMileTravel: 2.5,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.6",
            totalRatings: 1000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "103357",
            name: "Gurukripa South Tukoganj (DUTT)",
            uuid: "97cf79bc-9982-482a-8b8a-dbe261c20ca7",
            city: "18",
            area: "South Tukoganj",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "wbhvshhcwdzvrvuxfpsq",
            cuisines: [
              "North Indian",
              "South Indian",
              "Chinese",
              "Snacks",
              "Thalis",
              "Desserts",
              "Punjabi",
              "Beverages",
              "Indian",
              "Jain",
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 25,
            minDeliveryTime: 25,
            maxDeliveryTime: 25,
            slaString: "25 MINS",
            lastMileTravel: 3,
            slugs: {
              restaurant: "dutt-gurukripa-south-tukoganj-south-tukoganj",
              city: "indore",
            },
            cityState: "18",
            address: "10, Shanti Mandapum, South Tukoganj, Indore",
            locality: "Shanti Mandapum",
            parentId: 92206,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹120 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹120 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            ribbon: [
              {
                type: "PROMOTED",
              },
            ],
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 3400,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 3400,
              message: "",
              title: "Delivery Charge",
              amount: "3400",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
              "cid=6463640~p=7~eid=00000187-70ef-5d98-2ad3-45d700600738",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "3 kms",
            hasSurge: false,
            sla: {
              restaurantId: "103357",
              deliveryTime: 25,
              minDeliveryTime: 25,
              maxDeliveryTime: 25,
              lastMileTravel: 3,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.0",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "611822",
            name: "Thali Company",
            uuid: "4e9547ed-eb6f-4669-a8d6-0a94449ae8f7",
            city: "18",
            area: "Vijay Nagar",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "au9dkfzgdpxolec9s0rg",
            cuisines: ["North Indian", "Indian"],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 20,
            minDeliveryTime: 20,
            maxDeliveryTime: 20,
            slaString: "20 MINS",
            lastMileTravel: 1.2000000476837158,
            slugs: {
              restaurant: "the-thali-company-vijay-nagar-vijay-nagar",
              city: "indore",
            },
            cityState: "18",
            address:
              "161-A ADARSH MECHANIC NAGAR, Indore,  Indore, Indore, Madhya Pradesh - 452011",
            locality: "Adarsh Mechanic Nagar",
            parentId: 354462,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [],
              totalFees: 0,
              message: "",
              title: "",
              amount: "",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.2 kms",
            hasSurge: false,
            sla: {
              restaurantId: "611822",
              deliveryTime: 20,
              minDeliveryTime: 20,
              maxDeliveryTime: 20,
              lastMileTravel: 1.2000000476837158,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.7",
            totalRatings: 100,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "400810",
            name: "Rambles Restaurant",
            uuid: "ac6a0141-b9ad-4dbe-a6b3-b19950d29a69",
            city: "18",
            area: "Vijay Nagar",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "47573a3dc321d605e6e49475dccf25a5",
            cuisines: [
              "North Indian",
              "Mughlai",
              "Fast Food",
              "Biryani",
              "Snacks",
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 23,
            minDeliveryTime: 23,
            maxDeliveryTime: 23,
            slaString: "23 MINS",
            lastMileTravel: 0.5,
            slugs: {
              restaurant: "rambles-restaurant-new-palasia-new-palasia",
              city: "indore",
            },
            cityState: "18",
            address: "DS-36 SHOPPING COMPLEX A.B. ROAD INDORE 452010",
            locality: "Vijay Nagar",
            parentId: 253424,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "0.5 kms",
            hasSurge: false,
            sla: {
              restaurantId: "400810",
              deliveryTime: 23,
              minDeliveryTime: 23,
              maxDeliveryTime: 23,
              lastMileTravel: 0.5,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.9",
            totalRatings: 100,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "64823",
            name: "Nafees Restaurant",
            uuid: "182b7dcf-3a45-45f1-846a-b73cc209ecad",
            city: "18",
            area: "Old Palasia",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "x7zvrb5mbg92skzncwnu",
            cuisines: [
              "Mughlai",
              "Biryani",
              "North Indian",
              "Chinese",
              "Snacks",
              "Desserts",
              "Beverages",
            ],
            tags: [],
            costForTwo: 35000,
            costForTwoString: "₹350 FOR TWO",
            deliveryTime: 25,
            minDeliveryTime: 25,
            maxDeliveryTime: 25,
            slaString: "25 MINS",
            lastMileTravel: 1.5,
            slugs: {
              restaurant: "nafees-restaurant-old-palasia-old-palasia",
              city: "indore",
            },
            cityState: "18",
            address: "30-B, Apollo Avenue, Old Palasia, Indore",
            locality: "Greater Kailash Road",
            parentId: 10713,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "Flat ₹125 off",
              shortDescriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "₹125 OFF",
              shortDescriptionList: [
                {
                  meta: "Use MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                  discountType: "Flat",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            ribbon: [
              {
                type: "PROMOTED",
              },
            ],
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
              "cid=6463272~p=10~eid=00000187-70ef-5d98-2ad3-45d800600a65",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.5 kms",
            hasSurge: false,
            sla: {
              restaurantId: "64823",
              deliveryTime: 25,
              minDeliveryTime: 25,
              maxDeliveryTime: 25,
              lastMileTravel: 1.5,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.0",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "84070",
            name: "Gurukripa Restaurant  Sarwate",
            uuid: "1e86e574-fa54-48f8-96f7-7ba27b0f635b",
            city: "18",
            area: "South Tukoganj",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "g5txnz35wlrgbskk3r8y",
            cuisines: [
              "North Indian",
              "Thalis",
              "Indian",
              "Fast Food",
              "Chinese",
              "Beverages",
              "Desserts",
              "Jain",
              "Punjabi",
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 25,
            minDeliveryTime: 25,
            maxDeliveryTime: 25,
            slaString: "25 MINS",
            lastMileTravel: 3.9000000953674316,
            slugs: {
              restaurant: "shree-gurukripa-sarwate-bus-stand-south-tukoganj",
              city: "indore",
            },
            cityState: "18",
            address: "Sarwate Bus Stand, Indore",
            locality: "Sarwate",
            parentId: 92204,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹120 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹120 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 3400,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 3400,
              message: "",
              title: "Delivery Charge",
              amount: "3400",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "3.9 kms",
            hasSurge: false,
            sla: {
              restaurantId: "84070",
              deliveryTime: 25,
              minDeliveryTime: 25,
              maxDeliveryTime: 25,
              lastMileTravel: 3.9000000953674316,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "4.0",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "436748",
            name: "Bansuri Wala",
            uuid: "b3557b3f-17cf-4273-be20-27edf39f3a37",
            city: "18",
            area: "Ayodhya Puri",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "uvrbovbnnvjaod7fnud1",
            cuisines: [
              "North Indian",
              "Fast Food",
              "Chinese",
              "Snacks",
              "Beverages",
            ],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "₹200 FOR TWO",
            deliveryTime: 20,
            minDeliveryTime: 20,
            maxDeliveryTime: 20,
            slaString: "20 MINS",
            lastMileTravel: 1.2000000476837158,
            slugs: {
              restaurant: "bansuriwala-old-palasia-old-palasia",
              city: "indore",
            },
            cityState: "18",
            address:
              "3, near sputnik press, Ayodhya Puri, Indore, Madhya Pradesh 452010, India",
            locality: "Ayodhya Puri",
            parentId: 41610,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.2 kms",
            hasSurge: false,
            sla: {
              restaurantId: "436748",
              deliveryTime: 20,
              minDeliveryTime: 20,
              maxDeliveryTime: 20,
              lastMileTravel: 1.2000000476837158,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.5",
            totalRatings: 1000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "63273",
            name: "Sanjha Chulha",
            uuid: "f74bea0f-47a5-4b55-ae9d-5fc27aaf526e",
            city: "18",
            area: "Vijay Nagar",
            totalRatingsString: "10000+ ratings",
            cloudinaryImageId: "i673c8okei5gr2mwfygh",
            cuisines: ["North Indian", "Chinese", "Mughlai", "Thalis"],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 24,
            minDeliveryTime: 24,
            maxDeliveryTime: 24,
            slaString: "24 MINS",
            lastMileTravel: 3,
            slugs: {
              restaurant: "sanjha-chulha-vijay-nagar-vijay-nagar",
              city: "indore",
            },
            cityState: "18",
            address:
              "3, AG 242, Sukhsagar Apartment, Scheme 54, Vijay Nagar, Indore",
            locality: "54 Scheme",
            parentId: 1356,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "50% off",
              shortDescriptionList: [
                {
                  meta: "50% off | Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "50% off up to ₹100 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "50% OFF",
              shortDescriptionList: [
                {
                  meta: "Use TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "50% off up to ₹100 | Use code TRYNEW",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            ribbon: [
              {
                type: "PROMOTED",
              },
            ],
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 3400,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 3400,
              message: "",
              title: "Delivery Charge",
              amount: "3400",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID:
              "cid=6368283~p=13~eid=00000187-70ef-5d98-2ad3-45d900600d24",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "3 kms",
            hasSurge: false,
            sla: {
              restaurantId: "63273",
              deliveryTime: 24,
              minDeliveryTime: 24,
              maxDeliveryTime: 24,
              lastMileTravel: 3,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.2",
            totalRatings: 10000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "604471",
            name: "The Rajbhog",
            uuid: "b69dc504-6f65-48ed-ad6a-3a12eb27da2d",
            city: "18",
            area: "New Palasia",
            totalRatingsString: "100+ ratings",
            cloudinaryImageId: "uqkzlr7pophcojrohpqi",
            cuisines: [
              "North Indian",
              "Thalis",
              "Indian",
              "Chinese",
              "Fast Food",
              "Biryani",
            ],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 21,
            minDeliveryTime: 21,
            maxDeliveryTime: 21,
            slaString: "21 MINS",
            lastMileTravel: 1.2000000476837158,
            slugs: {
              restaurant: "the-rajbhog-new-palasia-new-palasia",
              city: "indore",
            },
            cityState: "18",
            address:
              "02 Ayodhyapuri Colony, Near LIG Square,,  Indore, Indore, Indore, Madhya Pradesh -  452010",
            locality: "Ayodhyapuri Colony",
            parentId: 360253,
            unserviceable: false,
            veg: true,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.2 kms",
            hasSurge: false,
            sla: {
              restaurantId: "604471",
              deliveryTime: 21,
              minDeliveryTime: 21,
              maxDeliveryTime: 21,
              lastMileTravel: 1.2000000476837158,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.6",
            totalRatings: 100,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "658427",
            name: "Dormito's Pizza",
            uuid: "597f730d-da0b-4865-843b-74ab39471eba",
            city: "18",
            area: "New Palasia",
            totalRatingsString: "20+ ratings",
            cloudinaryImageId: "f743877621762bceed7fe0b9a7be3a54",
            cuisines: ["Pizzas", "Fast Food"],
            tags: [],
            costForTwo: 25000,
            costForTwoString: "₹250 FOR TWO",
            deliveryTime: 21,
            minDeliveryTime: 21,
            maxDeliveryTime: 21,
            slaString: "21 MINS",
            lastMileTravel: 0.5,
            slugs: {
              restaurant: "dormito's-pizza-new-palasia-new-palasia-2",
              city: "indore",
            },
            cityState: "18",
            address:
              "139-B, AMBEDKAR NAGAR, INDORE, Indore, Indore, Indore, Madhya Pradesh - 452001",
            locality: "Ambedkar nagar",
            parentId: 395548,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "60% off",
              shortDescriptionList: [
                {
                  meta: "60% off | Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "60% OFF",
              shortDescriptionList: [
                {
                  meta: "Use WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "60% off up to ₹100 | Use code WELCOMEBACK",
                  discountType: "Percentage",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "0.5 kms",
            hasSurge: false,
            sla: {
              restaurantId: "658427",
              deliveryTime: 21,
              minDeliveryTime: 21,
              maxDeliveryTime: 21,
              lastMileTravel: 0.5,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.9",
            totalRatings: 20,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
      {
        cardType: "restaurant",
        layoutAlignmentType: "VERTICAL",
        data: {
          type: "restaurant",
          data: {
            type: "F",
            id: "67385",
            name: "Pizza Hut",
            uuid: "80515522-2faf-49e0-a55d-0754e547559b",
            city: "18",
            area: "Vijay Nagar",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "rgg9dxadhrhcavj1v7c0",
            cuisines: ["Pizzas"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 27,
            minDeliveryTime: 27,
            maxDeliveryTime: 27,
            slaString: "27 MINS",
            lastMileTravel: 1.399999976158142,
            slugs: {
              restaurant: "pizza-hut-malhar-mega-mall-vijay-nagar",
              city: "indore",
            },
            cityState: "18",
            address:
              "SHOP NO.-1, 2nd FLOOR, MALHAR MEGA MALL, NEAR C21MALL, VIJAY NAGAR AB ROAD, INDORE-452010, Indore,Indore(Madhya Pradesh) -452010",
            locality: "MALHAR MEGA MALL",
            parentId: 721,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
              header: "Free Margherita Pizza",
              shortDescriptionList: [
                {
                  meta: "Free Margherita Pizza on orders above ₹199",
                  discountType: "Freebie",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Free Margherita Pizza on orders above ₹199",
                  discountType: "Freebie",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
              header: "",
              shortDescriptionList: [
                {
                  meta: "Free Margherita Pizza",
                  discountType: "Freebie",
                  operationType: "RESTAURANT",
                },
              ],
              descriptionList: [
                {
                  meta: "Free Margherita Pizza on orders above ₹199",
                  discountType: "Freebie",
                  operationType: "RESTAURANT",
                },
              ],
              subHeader: "",
              headerType: 0,
              superFreedel: "",
            },
            chain: [],
            feeDetails: {
              fees: [
                {
                  name: "distance",
                  fee: 2700,
                  message: "",
                },
                {
                  name: "time",
                  fee: 0,
                  message: "",
                },
                {
                  name: "special",
                  fee: 0,
                  message: "",
                },
              ],
              totalFees: 2700,
              message: "",
              title: "Delivery Charge",
              amount: "2700",
              icon: "",
            },
            availability: {
              opened: true,
              nextOpenMessage: "",
              nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
              imageBased: [],
              textBased: [],
              textExtendedBadges: [],
            },
            lastMileTravelString: "1.3 kms",
            hasSurge: false,
            sla: {
              restaurantId: "67385",
              deliveryTime: 27,
              minDeliveryTime: 27,
              maxDeliveryTime: 27,
              lastMileTravel: 1.399999976158142,
              lastMileDistance: 0,
              serviceability: "SERVICEABLE",
              rainMode: "NONE",
              longDistance: "NOT_LONG_DISTANCE",
              preferentialService: false,
              iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.5",
            totalRatings: 1000,
            new: false,
          },
          subtype: "basic",
        },
        parentWidget: false,
      },
    ],
    nextPageFetch: 0,
  },
  tid: "5d29f1ba-57e3-40af-9ea6-755f41a0fcea",
  sid: "6fw1a926-75d3-4ea9-8467-0ddc925abeda",
  deviceId: "ac04c0a7-9f93-eaec-ee26-b3479eb0e625",
  csrfToken: "nfOHhMN8Hjqz-FrZWNV0zrIzB2iwGVoWHqgrv2Ww",
};

